import { useEffect } from 'react';

import { useSupportChatStore } from '../supportChatStore.ts';
import { getSessionStorage } from '../sessionStorage/sessionStorage.ts';
import { type SupportChatType } from '../types.ts';

function useSupportChatType(options?: {
    overrideChatType?: SupportChatType;
}): SupportChatType | null {
    const chatType = useSupportChatStore(state => state.chatType);
    const hasActiveChat = useSupportChatStore(state => state.hasActiveChat);
    const setChatType = useSupportChatStore(state => state.setChatType);

    useEffect(() => {
        const sessionStorage = getSessionStorage();

        if (sessionStorage.activeChat) {
            setChatType(sessionStorage.activeChat);
            return;
        }

        const store = useSupportChatStore.getState();
        const currentChatType = store.chatType;

        if (currentChatType && hasActiveChat) {
            return;
        }

        if (options?.overrideChatType) {
            setChatType(options.overrideChatType);
            return;
        }

        setChatType('SIERRA');
    }, [options, hasActiveChat, setChatType]);

    return chatType;
}

export { useSupportChatType };
